/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded YoutubeSearchedFor.
 * @export
 */
export const ICON_YOUTUBE_SEARCHED_FOR = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.1552 16.8847H19.2218L18.9068 16.5697C20.2485 15.0063 20.9602 12.9063 20.6685 10.6313C20.2718 7.55135 17.9268 4.96135 14.8935 4.26135C9.94682 3.11801 5.57182 7.00301 5.57182 11.6347H3.12182C2.57348 11.6347 2.32848 12.323 2.76015 12.673L6.72682 15.8813C6.94848 16.1147 7.32182 16.1263 7.55515 15.893L10.9385 12.638C11.3118 12.2763 11.0552 11.6347 10.5302 11.6347H7.90515C7.90515 8.72968 10.2385 6.40801 13.1085 6.38468C15.9552 6.36135 18.4052 8.77635 18.4052 11.623C18.4052 14.5163 16.0485 16.8847 13.1552 16.8847C12.6302 16.8847 12.1168 16.803 11.6385 16.663C11.2418 16.5463 10.8102 16.663 10.5185 16.9663C9.90015 17.5847 10.1452 18.658 10.9735 18.903C11.6618 19.1013 12.3968 19.218 13.1552 19.218C15.0335 19.218 16.7485 18.5297 18.0785 17.3863L18.3935 17.7013V18.623L23.3752 23.5813C23.8535 24.0597 24.6235 24.0597 25.1018 23.5813C25.5802 23.103 25.5802 22.3213 25.1018 21.843L20.1552 16.8847Z"
      fill="#707070"
    />
  </svg>
);
